module.exports = __webpack_public_path__ + "img/rey.c1ce6137.png";